export function buildThreeDsAdditionalData(nameOnCard: string, email?: string | null): {
  email?: string
  billingAddress?: { firstName?: string, lastName?: string }
} {
  const [firstName, ...rest] = nameOnCard.trim().split(/\s+/).filter(Boolean);
  const lastName = rest.join(' ');

  return {
    ...(email ? { email } : {}),
    ...(firstName ? { billingAddress: { firstName, ...(lastName ? { lastName } : {}) } } : {}),
  };
}
